import styles from './styles.module.scss';

import { useEffect, useMemo, useRef, useState } from 'react';

import { animate, motion, useDragControls, useMotionValue } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faEye, faFilter, faGripLines, faLocation, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import MapWithListingData from '../../../Misc/MapWithListingData/MapWithListingData';

import { PuffLoader, ScaleLoader } from 'react-spinners';
import Head from 'next/head';
import errorMsg from '../../../Functions/errorMsg';
import axios from 'axios';
import Image from 'next/image';

import Listing from '../../../Account/Marketplace/Listing/Listing';

import Filter from '../../../Filters/Filter';
import { useRouter } from 'next/router';
export default function Trading() {
  const router = useRouter();
  // Loading state variables
  const [mapLoading, setMapLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);

  const [listingData, setListingData] = useState(null);
  const [selectedData, setSelectedData] = useState([]);
  const [showingData, setShowingData] = useState([]);

  const [availableObjects, setAvailableObjects] = useState(null);

  useEffect(() => {
    if(!dataLoading || listingData || availableObjects) return;

    async function getListingData() {
      const result = await axios.get(`${window.location.origin}/api/marketplace/general/tradingListings`).catch((error) => errorMsg(error?.response?.data?.status || error.toString()))

      if(result && result.status === 200) {
        const data = result.data;
        setListingData(data.listings);
        setAvailableObjects(data.availableObjects)
      }
    }

    getListingData();

    setDataLoading(false);
    

  }, [dataLoading, listingData, availableObjects])

  useEffect(() => {
    if(!listingData) return;
    if(listingData?.length === 0) return;
    if(router?.query?.popup === 'sharedPost') {
      const getListingID = router.query._id;
      showClickedListing(getListingID)
    }
  }, [router, listingData])

    // Map Interaction Click Handler
  // =============================
  const [searchText, setSearchText] = useState('');
  const [selectedObjects, setSelectedObjects] = useState([]);

  useEffect(() => {
    if(!listingData) return;
    if(searchText.length > 0) {
      const filteredListings = listingData.filter((listing) => {
        const searchTextCheck = searchText.trim().toLowerCase();
        const title = listing.title.trim().toLowerCase();
        const description = listing.description.trim().toLowerCase();
        const category = listing.category.trim().toLowerCase();
    
        return (
          title.includes(searchTextCheck) ||
          description.includes(searchTextCheck) ||
          category.includes(searchTextCheck)
        );
      });

      setSelectedData(filteredListings);
      setShowingData(filteredListings);
    } else {
      const filteredListings = listingData.filter((listing) => selectedObjects.includes(listing.zip));
      setSelectedData(filteredListings);
      setShowingData(filteredListings);
    }
  }, [listingData, searchText])

  useEffect(() => {
    if (selectedObjects.length > 0) {
      const filteredListings = listingData.filter((listing) => selectedObjects.includes(listing.zip));
      setSelectedData(filteredListings);
      setShowingData(filteredListings);
    } else {
      if(searchText.length > 0) {
        const filteredListings = listingData.filter((listing) => {
          const searchTextCheck = searchText.trim().toLowerCase();
          const title = listing.title.trim().toLowerCase();
          const description = listing.description.trim().toLowerCase();
          const category = listing.category.trim().toLowerCase();
      
          return (
            title.includes(searchTextCheck) ||
            description.includes(searchTextCheck) ||
            category.includes(searchTextCheck)
          );
        });
  
        setSelectedData(filteredListings);
        setShowingData(filteredListings);
      } else {
        setSelectedData([]);
        setShowingData([]);
      }
    }
  }, [selectedObjects, listingData, searchText]);

  function handleObjectClick(obj) {
    setSelectedObjects(prevObjects => {
      if (prevObjects.includes(obj)) {
        return prevObjects.filter((curObj) => curObj !== obj);
      } else {
        return [...prevObjects, obj];
      }
    });
  }

  function isLoading() {
    if(mapLoading || dataLoading) return true;
    return false;
  }

  // FILTER STUFF

  const [filterBar, setFilterBar] = useState(false);

  const showFilterBar = () => {
    if(isLoading()) return;
    setFilterBar(prevFilterBar => !prevFilterBar);
  }

  function filterApplyArray(newArray) {
    setShowingData(newArray);
  }

  function clearFilter() {
    setShowingData(selectedData);
  }

  // =============================
  // =============================

  const [clickedListing, showClickedListing] = useState(null);

  const memoizeListingContainer = useMemo(() => <ListingContainer noListings={listingData?.length === 0} listings={showingData} showFilterBar={showFilterBar} handleSearchMethod={(text) => setSearchText(text)} handleOpenListing={(listingID) => showClickedListing(listingID)} /> , [showingData, listingData]);
  const memoizeMap = useMemo(() => <MapWithListingData type='ZIP' availableObjects={availableObjects} listingData={listingData} handleMapLoaded={() => setMapLoading(false) } handleClick={handleObjectClick} /> , [listingData, availableObjects])
  
  return (
    <section id={styles.wrapper}>
      { clickedListing && <Listing listingID={clickedListing} closeListing={() => showClickedListing(null)} /> }
      <Filter isLoading={isLoading()} filterType="Trading" unfilteredData={selectedData} allResults={showingData} filterBar={filterBar} showFilterBar={showFilterBar} filterApplyArray={filterApplyArray} clearFilter={clearFilter} />
      <Head>
          <title>Waco Local Marketplace - Buy / Sell</title>
          <meta name="description" content="Waco Exchange's Marketplace is a convenient destination on Waco Exchange to buy and sell items within your local community. Waco Exchange Marketplace was created to weed out bots and scammers, and become more tailored to locality." key="desc" />

          <meta property="og:title" content="Waco Local Marketplace - Buy / Sell" />
          <meta property="og:description" content="Waco Exchange's Marketplace is a convenient destination on Waco Exchange to buy and sell items within your local community. Waco Exchange Marketplace was created to weed out bots and scammers, and become more tailored to locality." />

      </Head>

      { isLoading() && <div id={styles.loading}> <ScaleLoader width={50} height={40} color='white' /> </div> }

      <div id={styles.controls}>
        
      </div>

      <section id={styles.content}>
        { listingData && <h1 id={styles.mapTypeText}>Trades Map</h1> }
        { listingData && memoizeMap}
        { listingData && memoizeListingContainer}
      </section>

    </section>
  )
}

const ListingContainer = ({ listings, showFilterBar, handleSearchMethod, handleOpenListing, noListings}) => {

  // Handling Listing Container Drag Controls & Animation
  // ====================================================
  const [showDisplayed, setShowDisplayed] = useState(false);
  const controls = useDragControls();
  const y = useMotionValue(showDisplayed ? 0 : 400);

  const onClickHandle = () => {
    if(showDisplayed) {
      setShowDisplayed(false)
      animate(y, 400, { type: 'tween', stiffness: 1000, damping: 10, bounce: 0 });
    } else {
      setShowDisplayed(true);
      animate(y, 0, { type: 'tween', stiffness: 1000, damping: 10, bounce: 0 });
    }
  }

  const onDragEnd = (_, info) => {
    const velocity = info.velocity.y;
    if (velocity > 0) {
      setShowDisplayed(false);
      animate(y, 400, { type: 'tween', stiffness: 1000, damping: 10, bounce: 0 });
    } else if (velocity < 0) {
      setShowDisplayed(true);
      animate(y, 0, { type: 'tween', stiffness: 1000, damping: 10, bounce: 0 });
    }
  };
  // ====================================================
  // ====================================================

  const displayContainerRef = useRef(null);

  const [showToTop, setShowToTop] = useState(false);

  const handleScroll = () => {
    if (!displayContainerRef || !displayContainerRef?.current) return;
    const position = displayContainerRef.current.scrollTop;

    if(position > 200) {
      setShowToTop(true);
    } else {
      setShowToTop(false);
    }

  };

  function handleScrollUp(e) {
    e.preventDefault();
    if (!displayContainerRef || !displayContainerRef?.current) return;
    displayContainerRef.current.scroll({top: 0, behavior: 'smooth' })
  }

  useEffect(() => {
    if(!displayContainerRef || !displayContainerRef?.current) return;

      displayContainerRef.current.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      if (!displayContainerRef || !displayContainerRef?.current) return;
      displayContainerRef.current.removeEventListener('scroll', handleScroll);
    };
  }, [displayContainerRef]);

  // Search Methods:

  const searchInputRef = useRef(null);

  function handleSearch() {
    if(!searchInputRef) return;
    if(!searchInputRef?.current) return;

    const text = searchInputRef.current.value;

    handleSearchMethod(text);
  }

  return (
    <motion.section id={styles.viewListings} style={{ y }} drag='y' dragElastic={0} dragConstraints={{ top: 0, bottom: 400 }} dragListener={false} dragControls={controls} onDragEnd={onDragEnd} >
      <div>
        <FontAwesomeIcon onClick={onClickHandle} icon={faGripLines} id={styles.handleContainerIcon} size='lg' onPointerDown={(e) => controls.start(e) } />
      </div>
      
      <div ref={displayContainerRef} id={styles.displayContainer}>
        { showToTop && <div id={styles.toTop}> <FontAwesomeIcon onClick={handleScrollUp} icon={faChevronUp} id={styles.icon} /> </div> }

        <section id={styles.queryMethods}>
          <div>
            <input ref={searchInputRef} placeholder='Search...' />
            <div onClick={handleSearch}> <FontAwesomeIcon icon={faMagnifyingGlass} id={styles.searchButton} /> </div>
          </div>
          <div>
            <FontAwesomeIcon icon={faFilter} id={styles.filter} onClick={showFilterBar} />
          </div>
          <div>
          </div>
        </section>

        {listings.length > 0 && listings.map((listing, index) => <DisplayCard key={index} listing={listing} handleOpenListing={handleOpenListing} />)}
        { noListings && listings.length === 0 && <h1>No Listings</h1> }
        { !noListings && listings.length === 0 && <h1>Select Map</h1> }

      </div>
    </motion.section>
  )
}

const DisplayCard = ({ listing, handleOpenListing }) => {

  const listingID = listing._id;

  const [coverLoaded, setCoverLoaded] = useState(false);
  const getCover = listing.images.findIndex((images) => images.position === 1);

  return (
    <div className={styles.displayCard} onClick={() => handleOpenListing(listingID)}>
      
      <div>
        <div style={{display: coverLoaded === false ? 'flex' : 'none'}}> <PuffLoader color="#424242" size={25} /></div>
        <Image sizes='auto auto' fill src={listing.images[getCover].url} alt={listing.images[getCover].url} onLoadingComplete={() => setCoverLoaded(true)} />
      </div>

      <div>
        <section>
          <h1>{listing.title}</h1>
          <h2>{listing.category}</h2>
        </section>
        <section>
          <h3>Trade</h3>
          <h3><FontAwesomeIcon icon={faLocation} id={styles.icon} />{listing.zip}</h3>
        </section>

      </div>

      <div>
        <h1>{listing.condition}</h1>
        <h2 style={{display: listing.views.length >= 5 ? 'flex' : 'none'}}><FontAwesomeIcon icon={faEye} id={styles.icon} /> {listing.views.length} </h2>
      </div>

    </div>
  )
}